var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.568,
    height: 9.242,
    viewBox: "0 0 11.568 9.242",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_152",
    "data-name": "Union 152",
    d: "M-15.873,5.944-18.718,2.93a1.063,1.063,0,0,1,0-1.441.924.924,0,0,1,1.36,0l2.165,2.294L-9.074-2.7a.924.924,0,0,1,1.36,0,1.061,1.061,0,0,1,0,1.441l-6.8,7.2a.932.932,0,0,1-.68.3A.932.932,0,0,1-15.873,5.944Z",
    transform: "translate(19 3)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTick);
export default __webpack_public_path__ + "static/media/icon-tick.7d21adf3.svg";
export { ForwardRef as ReactComponent };